var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#FF6A61",
    transform: "translate(-428 -636) translate(308 624) translate(120 11) rotate(-45 11.121 3.879)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H6V6H0z"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#FFF",
    fontFamily: "Poppins-SemiBold, Poppins",
    fontSize: 8,
    fontWeight: 500,
    transform: "translate(-428 -636) translate(308 624) translate(120 11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6.848,
    y: 12
  }, "?"))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHelp);
export default __webpack_public_path__ + "static/media/ico-help.85c40b7cfec6a4b2dae16799abed8b4d.svg";
export { ForwardRef as ReactComponent };